import styled from "styled-components";


export const TooltipContainerInvoice = styled.div`
  position: absolute;
  // top: 44.3%;
  display: inline-block;
  background-color: #313131;
  padding: 8px;
  margin: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: 100%; /* Position it just below the tooltip */
    left: 50%;
    border: solid transparent;
    border-width: 5px; /* Adjust the size of the arrow */
    border-top-color: #313131; /* Set arrow color to match tooltip background */
    transform: translateX(-50%) rotate(0deg); /* Rotate the arrow */
    display: block;
  }
`;


export const CalculationContainer = styled.div`
  display: grid;
  /* grid-template-columns: 40px 130px ${({ grand }) =>
    grand ? "auto" : "110px"} 40px 40px minmax(
      auto,
      200px
    ); */
  grid-template-columns: auto auto;
  grid-gap: ${({ gap }) => gap || "20px 20px"};
  justify-content: flex-end;
  align-items: center;
  padding: ${({ padding, grand }) =>
    padding ? padding : grand ? `15px 10px` : `10px`};
  background-color: ${({ grand }) => grand && `#f8f9fc`};
  margin-top: ${({ grand }) => grand && `20px`};
`;

export const GrandTotalAmountSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 0px;
  gap: 10px;
  width: 200px;
  height: 48px;
  flex: none;
  flex-grow: 1;
`;

export const GrandTotalAmount = styled.div`
  width: 70px;
  height: 21px;
  font-family: "Mona Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.main.primary};
  flex: none;
  flex-grow: 0;
`;

export const VisitDateBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;
  width: 150px;
  /* height: 76px; */
  background: ${({ isSelected }) => (isSelected ? "#EDF8FE" : "transparent")};
  border: 1px solid ${({ isSelected }) => (isSelected ? "#2266EF" : "#9DA6A5")};
  border-radius: 8px;
  transition: all 0.2s ease;
  flex: none;
`;

export const CheckIconContainer = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  flex: none;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }
`;

export const CheckIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ isSelected }) => (isSelected ? "#2266EF" : "transparent")};
  border: 1px solid ${({ isSelected }) => (isSelected ? "#2266EF" : "#9DA6A5")};
  transition: all 0.2s ease;

  img {
    width: 12px;
    height: 12px;
  }
`;

export const VisitDateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  flex: none;
`;

export const VisitDateInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 2px;
  flex: none;
  flex-grow: 0;
`;

export const VisitDate = styled.div`
  font-family: "Mona Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #000e2a;
  flex: none;
  flex-grow: 0;
`;

export const VisitTime = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #353a46;
  flex: none;
  flex-grow: 0;
`;

export const VisitStatus = styled.div`
  font-weight: ${({ isSelected }) => (isSelected ? 500 : 400)};
  font-size: 12px;
  color: ${({ status }) => {
    if (status === "completed") return "#2266EF";
    if (status === "upcoming") return "#1C4F4A";
    if (status === "past") return "#9DA6A5";
    return "#353A46";
  }};
`;

export const GrandTotalContainer = styled.div`
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 2;
  width: 100%;
  align-items: center;
  padding: 0px;
  gap: 20px;
  height: 48px;
  background: #ffffff;
  border-radius: 8px;
  flex: none;
  align-self: stretch;
`;

export const GrandTotalLabelSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 130px;
  height: 48px;
  flex: none;
  flex-grow: 1;
`;

export const GrandTotalLabel = styled.div`
  width: 174px;
  height: 21px;
  font-family: 'Mona Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #06100f;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #9da6a5;
  border-radius: 6px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.main.text || "#333"};
  background-color: white;

  &::placeholder {
    color: #c2cce1;
  }

  &:focus {
    border-color: #ff6600;
    outline: none;
  }
`;


export const TaxAmountLabel = styled.label`
  font-size: 14px;
  color: ${({ theme }) => theme.font.pageText.colorSecondary};
`;

export const TaxAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TaxAmountInput = styled.input`
  border: none;
  outline: none;
  padding: 0;
  font-size: 14px;
  max-width: 150px;
  background: transparent;
  color: ${({ theme }) => theme.colors.main.text || "#333"};

  &::placeholder {
    color: #9da6a5;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;


export const TaxAmountInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 0 4px 0 12px;
 background-color: ${({ bgColor, error, theme }) =>
    error
      ? theme.input.bgColor.error
      : bgColor
      ? bgColor
      : theme.input.bgColor.default};
  border: 1px solid
    ${({ borderColor, theme, error }) =>
      error
        ? theme.input.borderColor.error
        : borderColor
        ? borderColor
        : theme.input.borderColor.default};
  transition: border-color 0.2s ease;
  height: 40px;

  &:hover {
    border-color: ${({ hoverBorderColor, theme, error }) =>
      !error && (hoverBorderColor || theme.input.borderColor.hover)};
    box-shadow: ${({ theme, error }) => !error && theme.input.focusShadow};
  }
  &:focus {
    outline: none;
    border-color: ${({ focusBorderColor, theme, error }) =>
      !error && (focusBorderColor || theme.input.borderColor.focus)};
    box-shadow: ${({ theme, error }) => !error && theme.input.focusShadow};
  }
`;

export const TaxTypeToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
`;

export const TaxTypeToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  /* border-radius: 6px; */
  border-radius: ${({ active }) => (active ? "16px" : "8px")};
  border: ${({ active, theme }) =>
    `1px solid ${
      active ? theme.colors.border.primary : theme.colors.border.secondaryLight
    }`};
  color: ${({ active, theme }) =>
    active ? theme.colors.main.primary : theme.colors.main.labelText};
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.primary};
  }
`;

export const FileUploadContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
`;


export const FileUploadBox = styled.div`
  position: relative;
  height: 120px;
  width: 120px;
  border: 1px solid #c2cce1;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background-color: white;

  &:hover .delete-btn {
    display: flex;
  }
`;

export const UploadBox = styled.div`
  height: 120px;
  width: 120px;
  border: 1px dashed #c2cce1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f8f9fb;
  transition: all 0.2s;

  &:hover {
    border-color: #6776cb;
    background-color: #f0f2f8;
  }
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;


export const DeleteWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 5;
  display: none;
`;

export const DeleteButtonStyled = styled.button`
  background: rgba(239, 68, 68, 0.9);
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgba(239, 68, 68, 1);
  }
`;

export const FileName = styled.div`
  font-size: 12px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;
  font-weight: 500;
  max-width: 120px;
`;

export const IconTextOpenButton = styled.button`
display: flex;
height: 40px;
padding: 8px;
justify-content: center;
align-items: center;
gap: 5px;
align-self: stretch;
border-radius: 8px;
border: 1px solid #2266EF;
background: #FFFFFF;
cursor: pointer;
transition: all 0.2s ease;

&:hover {
  background-color: #EDF8FE;
}
`;

export const SignatureModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
`;

export const CanvasContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0;
  
  canvas {
    max-width: 100%;
  }
`;

export const CanvasModeToggle = styled.div`
  display: flex;
  gap: ${({ gap }) => gap || "12px"};
  margin-bottom: 16px;
`;

export const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
`;

export const UploadFileInput = styled.div`
  border: 2px dashed #c2cce1;
  border-radius: 8px;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f8f9fb;
  transition: all 0.2s;

  &:hover {
    border-color: #6776cb;
    background-color: #f0f2f8;
  }
`;

export const SignaturePreviewWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #f8f9fb;
  border-radius: 8px;
  min-height: 250px;
`;

export const PreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 180px;
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
  margin-top: 12px;
`;